var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmenIcon6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33186 17.7765C8.33186 16.5536 9.08185 15.5531 9.99852 15.5531C10.9152 15.5531 11.6652 16.5536 11.6652 17.7765C11.6652 18.9994 10.9152 20 9.99852 20C9.08185 20 8.33186 18.9994 8.33186 17.7765ZM19.7318 7.25959C20.0735 6.83713 20.0901 6.13674 19.7735 5.69205C17.2568 2.07893 13.6902 0 9.99852 0C6.30686 0 2.74021 2.06782 0.223556 5.68093C-0.0931092 6.13674 -0.0681093 6.83713 0.265223 7.24847C0.598555 7.67093 1.13189 7.63758 1.44022 7.19288C3.64021 4.02446 6.75686 2.21234 9.99852 2.21234C13.2402 2.21234 16.3485 4.02446 18.5568 7.19288C18.7235 7.42635 18.9401 7.54864 19.1651 7.54864C19.3651 7.54864 19.5735 7.44858 19.7318 7.24847V7.25959ZM15.5568 12.607C15.8985 12.1845 15.9152 11.4842 15.5985 11.0395C14.1568 8.96053 12.1152 7.77098 9.99852 7.77098C7.88186 7.77098 5.8402 8.96053 4.39854 11.0395C4.08187 11.4842 4.10687 12.1957 4.44021 12.607C4.77354 13.0295 5.30687 12.9961 5.6152 12.5514C6.7402 10.9283 8.34019 10.0056 9.99852 10.0056C11.6568 10.0056 13.2485 10.9394 14.3818 12.5514C14.5485 12.7849 14.7652 12.9072 14.9902 12.9072C15.1902 12.9072 15.3985 12.8071 15.5568 12.607Z",
    fill: "#5C6C68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmenIcon6);
export default __webpack_public_path__ + "static/media/amen-icon-6.beca0a71e6355d1c2d2ba6a7e8830dd1.svg";
export { ForwardRef as ReactComponent };